import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API_ROUTES } from '../config/api';
import '../styles/Register.css';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    currentWeight: '',
    targetWeight: '',
    weightDate: new Date().toISOString().split('T')[0]
  });
  const [error, setError] = useState('');

  // Effet de particules
  useEffect(() => {
    const createParticle = () => {
      const particles = document.querySelector('.particles');
      if (!particles) return;

      const particle = document.createElement('div');
      particle.className = 'particle';
      
      // Position aléatoire
      const x = Math.random() * window.innerWidth;
      const y = Math.random() * window.innerHeight;
      particle.style.left = `${x}px`;
      particle.style.top = `${y}px`;
      
      // Taille aléatoire
      const size = Math.random() * 10 + 5;
      particle.style.width = `${size}px`;
      particle.style.height = `${size}px`;
      
      particles.appendChild(particle);
      
      // Suppression après l'animation
      setTimeout(() => {
        particle.remove();
      }, 3000);
    };

    const interval = setInterval(createParticle, 500);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(API_ROUTES.REGISTER, {
        username: formData.username,
        email: formData.email,
        password: formData.password,
        currentWeight: parseFloat(formData.currentWeight),
        targetWeight: parseFloat(formData.targetWeight),
        weightDate: formData.weightDate
      });

      if (response.data.success) {
        localStorage.setItem('token', response.data.data.token);
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Une erreur est survenue lors de l\'inscription');
    }
  };

  return (
    <div className="register-container">
      <div className="particles"></div>
      <div className="register-card">
        <h2>Rejoignez HealthGuardian</h2>
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="register-form">
          <div className="form-group">
            <label htmlFor="username">Nom d'utilisateur</label>
            <input
              id="username"
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Entrez votre nom d'utilisateur"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Entrez votre email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Choisissez un mot de passe sécurisé"
              required
            />
          </div>

          <div className="weight-date-group">
            <div className="form-group">
              <label htmlFor="currentWeight">Poids actuel (kg)</label>
              <input
                id="currentWeight"
                type="number"
                name="currentWeight"
                value={formData.currentWeight}
                onChange={handleChange}
                step="0.1"
                placeholder="Ex: 75.5"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="weightDate">Date de la pesée</label>
              <input
                id="weightDate"
                type="date"
                name="weightDate"
                value={formData.weightDate}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="targetWeight">Poids cible (kg)</label>
            <input
              id="targetWeight"
              type="number"
              name="targetWeight"
              value={formData.targetWeight}
              onChange={handleChange}
              step="0.1"
              placeholder="Ex: 70.0"
              required
            />
          </div>

          <button type="submit" className="submit-button">
            Commencer l'aventure
          </button>
        </form>

        <div className="login-link">
          Déjà membre ? <Link to="/login">Connectez-vous</Link>
        </div>
      </div>
    </div>
  );
};

export default Register; 